export default "__VITE_ASSET__CcXFGQEE__";